<template>
    <t-modal
        v-model="isOpenModal"
        class="flex items-center justify-center z-2000"
        close="flex items-center justify-center bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50"
    >
        <div
            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100"
        >
            <svg
                class="h-6 w-6 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </div>
        <h3 class="text-center mt-3 text-lg leading-6 font-medium text-gray-900">
            {{ errorMessage }}
        </h3>
    </t-modal>
</template>

<script>
export default {
    name: 'OutOfStockModal',
    data() {
        return {
            isOpenModal: false,
            errorMessage: null
        }
    },

    created() {
        this.$bus.$on('cart-error', (error) => {
            if(error.response.data.errors.hasOwnProperty('giftCard')) {
                this.errorMessage = error.response.data.errors.giftCard[0]
                this.openModal()
            }
        })
    },

    methods: {
        openModal() {
            this.isOpenModal = true

            setTimeout(() => this.isOpenModal = false, 4000);
        }
    }

}
</script>

<style scoped>

</style>
